export const globalCompliance = {
  brandName: 'SNS',
  companyName: 'Studio Next Steps LLC',
  addressLines: ['4 Stayman Ct', 'Catonsville', 'MD 21228', 'USA'],
  serviceDisclosure:
    'Global EZTopup is a digital top-up service operated by Studio Next Steps LLC, a US-registered company. We provide prepaid mobile recharge and digital product purchase services for Myanmar telecom users. Global EZTopup does not provide money transfer, remittance, banking, cash-out, or financial services.',
  serviceDescription:
    'Today, Global EZTopup serves customers across multiple countries, helping families, friends, and communities stay connected through trusted digital services. As we grow, we remain committed to delivering secure transactions, excellent customer experiences, and technology-driven solutions that create real value for our users.',
} as const;
